/**
 * Custom Filters - Room Collection
 * Template-specific configuration for room/location collections
 *
 * Requires: custom-filters-core.js to be loaded first
 */

document.addEventListener('DOMContentLoaded', function() {
  // Get collection handle (slug) from URL
  let collectionHandle = window.location.pathname.split('/collections/')[1]?.split('/')[0] || 'all';

  // Room name mapping for handles that don't match the API's location name.
  // Shopify handleizes the collection title (e.g. "Entry & Foyer" -> "entry-foyer"), dropping
  // the spaces/ampersand the slug is built from. Map the URL handle to the real location name
  // here; slugify then turns it back into the API slug ("entry & foyer" -> entry-and-foyer).
  // Simple single-word rooms (e.g. "office") need no entry — they fall through to the handle.
  const ROOM_NAME_MAPPING = {
    'shop-by-kitchen': 'kitchen',
    'shop-by-bedroom': 'bedroom',
    'entry-foyer': 'entry & foyer',
  };

  // Room collections live at /api/collections/room-{location}
  const locationName = ROOM_NAME_MAPPING[collectionHandle.toLowerCase()] || collectionHandle;
  const collectionSlug = 'room-' + window.CustomFilters.slugify(locationName);

  window.CustomFilters.init({
    type: 'category',
    collectionHandle: collectionHandle,
    collectionSlug: collectionSlug,
    excludedFilters: ['categories', 'locations', 'trends', 'motorTypes'],
  });
});
